import {parseDate, sortDates} from "../../../../utilities";

export const columnsForSearchTableCertificatesForPrint = [
    {
        Header: "",
        accessor: "checked",
        editable: false,
        show: true,
        viewType:"checkbox",
    },
    {
        Header: "Рег.номер",
        accessor: "appNum",
        editable: false,
        show: true,
        viewType:"text"
    },
    {
        Header: "Дата регистрации",
        accessor: "appDate",
        editable: false,
        show: true,
        viewType:"text",
        sortType: (rowA, rowB, columnId) => {
            const dateA = parseDate(rowA.values[columnId]);
            const dateB = parseDate(rowB.values[columnId]);

            return sortDates(dateA, dateB);
        },
    },
    {
        Header: "ФИО",
        accessor: "fio",
        editable: false,
        show: true,
        viewType:"text"
    },
    {
        Header: "Идент.номер заявителя",
        accessor: "persNum",
        editable: false,
        show: true,
        viewType:"text"
    },
    {
        Header: "Дата рождения",
        accessor: "birthDate",
        editable: false,
        show: true,
        viewType:"text",
        sortType: (rowA, rowB, columnId) => {
            const dateA = parseDate(rowA.values[columnId]);
            const dateB = parseDate(rowB.values[columnId]);

            return sortDates(dateA, dateB);
        },
    },
    {
        Header: "Тип удостоверения",
        accessor: "licenseTypeName",
        editable: false,
        show: true,
        viewType:"text"
    },
    {
        Header: "Участок",
        accessor: "sectionName",
        editable: false,
        show: true,
        viewType:"text"
    },
    {
        Header: "Статус заявления",
        accessor: "statusName",
        editable: false,
        show: true,
        viewType:"text"
    },
]